export default __webpack_public_path__ + "static/media/Val.be13a4e6.png";